import axios from '@/api';
import authHeader from './auth-header';

class shareDirService {
    getCreateDirLinkToken(loginId, dir) {
        return axios.get(process.env.VUE_APP_API_URL + 'share/page/createPage', {
            params: {
                loginId,
                dir
            },
            headers: authHeader(),
            withCredentials: true
        })
    }

    // getShareDirFileList(token, subDir = '') {
    //     return axios.get(
    //         process.env.VUE_APP_API_URL + `share/page/${token}`,
    //         {
    //             params: { subDir },   // query
    //             headers: authHeader(),
    //             withCredentials: true
    //         }
    //     ).then(response => {
    //         return response.data
    //     })
    // }

    postCreateLinkToken(fileName, token, dir) {
        return axios.post(process.env.VUE_APP_API_URL + 'share/page/file/createLink', {
            fileName,
            token,
            dir,
        },
            {
                headers: authHeader(),
                withCredentials: true
            }).then(res => {
                return res.data;
            }).catch(error => {
                console.log(error);
            })
    }

    postBaseDirInToken(token) {
        return axios.post(process.env.VUE_APP_API_URL + 'share/page/baseDirInToken',
            {
                token,
            },
            {
                headers: authHeader(),
                withCredentials: true,
            }).then(response => {
                //console.log(response.data);
                return response.data;
            });
    }

    postShareFileDownChk(token, path) {
        return axios.post(process.env.VUE_APP_API_URL + 'share/page/file/download', {
            token,
            path
        },
            {
                headers: authHeader(),
                withCredentials: true
            }).then(response => {
                return response;
            }).catch(error => {
                console.log(error);
            })
    }





    async createShareLink() {
        return await axios.post(
            `${process.env.VUE_APP_API_URL}share/create`,
            {},
            {
                headers: authHeader(),
                withCredentials: true,
            }
        );
    }

    async getShareDirFileList(token, subDir = "") {
        return await axios.post(
            `${process.env.VUE_APP_API_URL}share/file-list`,
            {
                token,
                subDir,
            },
            {
                headers: authHeader(),
                withCredentials: true,
            }
        );
    }
}

export default new shareDirService();